import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

const LoginButton = () => {
  const { instance } = useMsal();

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    instance.initialize()
      .then(() => setIsInitialized(true))
      .catch((error) => console.error("Error al inicializar MSAL:", error));
  }, [instance]);

  const handleLogin = () => {
  if (!isInitialized) {
    console.warn("MSAL aún no está inicializado. Esperando...");
    return;
  }

  instance
    .loginPopup(loginRequest)
    .then((response) => {
      // 👇 Guardamos la cuenta como activa
      if (response && response.account) {
        instance.setActiveAccount(response.account);
        console.log("Cuenta activa establecida:", response.account.username);
      }
    })
    .catch((e) => {
      console.error("Error en loginPopup:", e);
    });
};


  return <button onClick={handleLogin}>Iniciar sesión</button>;
};

export default LoginButton;
